import { VALIDATION_USERNAME_REQUEST, CHECK_PATIENT_EXISTS_REQUEST, VERIFY_2FACODE_REQUEST, VALIDATE_PATIENT_EMAIL_PHONE, REGISTER_REQUEST } from "../Actions/types";
import { put, call } from "redux-saga/effects";

import * as registerActions from '../Actions/RegisterActions';
import { validateUsername, checkPatientExists, verifyCode, validateUser, registerUserV2 } from "../../../api/apiMethods/registerMethod";
import ResponseParser from "../../../api/apiResponseParser";
import AlertDialog from "../../../components/errorDialog";

export default function* registerSaga(actions) {
    if (actions.type === VALIDATION_USERNAME_REQUEST) {
        yield put(registerActions.enableLoader());
        yield put(registerActions.verify2faCodeResponse({}));
        const response = yield call(validateUsername, actions.payload);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            if (data && data.user) {
                yield put(registerActions.validateUserResponse(data.user));
            } else {
                yield put(registerActions.validateUserResponse({ doc_id: 1 }));
            }
            yield put(registerActions.saveUsername(actions.payload));
            yield put(registerActions.disableLoader({}));
        } else if (response.status == 422) {
            yield put(registerActions.disableLoader({}));
            yield put(registerActions.validateUserResponse({ doc_id: 1 }));
            yield put(registerActions.saveUsername(actions.payload));
        } else {
            yield put(registerActions.validateUserFailed({}));
            yield put(registerActions.onErrorOccured(data));
            yield put(registerActions.disableLoader({}));
            if (response.status == 401 || response.status == 403) {

            } else {
                console.log("Failed 2fa send");
            }
        }
        // if (data.status_code === 200) {
        //     yield put(registerActions.validateUserResponse(data.result));
        //     yield put(registerActions.saveUsername(actions.payload));
        //     yield put(registerActions.disableLoader());
        // } else {
        yield put(registerActions.disableLoader());
        //     yield put(registerActions.validateUserFailed([]));
        // }

    } else if (actions.type === CHECK_PATIENT_EXISTS_REQUEST) {
        yield put(registerActions.enableLoader());
        const response = yield call(checkPatientExists, actions.payload);
        let data = yield ResponseParser(response);
        if (data.status_code === 200) {
            yield put(registerActions.checkPatientExistsResponse(data.result[0]));
            yield put(registerActions.disableLoader());
        } else {
            yield put(registerActions.disableLoader());
            yield put(registerActions.checkPatientExistsFailed([]));
            yield put(registerActions.onErrorOccured(data));
        }
    }
    else if (actions.type === VERIFY_2FACODE_REQUEST) {
        yield put(registerActions.enableLoader());
        const response = yield call(verifyCode, actions.payload);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            if (data && data.token) {
                yield put(registerActions.verifyCodeResponse(data));
            } else if (data && data.fhir_patient_id) {
                yield put(registerActions.verify2faCodeResponse({ ...data, register: true }));
            } else {
                yield put(registerActions.verify2faCodeResponse({ register: true }));
            }
            yield put(registerActions.disableLoader({}));
        } else {
            yield put(registerActions.disableLoader());
            yield put(registerActions.verify2faCodeFailed([]));
            yield put(registerActions.onErrorOccured(data));
        }
        // if (data.status_code === 200) {
        //     yield put(registerActions.disableLoader());
        //     yield put(registerActions.verify2faCodeResponse(data));
        // } else {
        //     yield put(registerActions.disableLoader());
        //     yield put(registerActions.verify2faCodeFailed([]));
        // }
    } else if (actions.type == VALIDATE_PATIENT_EMAIL_PHONE) {
        yield put(registerActions.enableLoader({}));
        let query = '';
        if (actions.payload.username && actions.payload.username.length > 0) {
            query += `username=${actions.payload.username}&`;
        }
        if (actions.payload.firstName && actions.payload.firstName.length > 0) {
            query += `first_name=${actions.payload.firstName}&`;
        }
        if (actions.payload.lastName && actions.payload.lastName.length > 0) {
            query += `last_name=${actions.payload.lastName}&`;
        }
        if (actions.payload.dateOfBirth && actions.payload.dateOfBirth.length > 0) {
            query += `birth_date=${actions.payload.dateOfBirth}&`;
        }
        if (actions.payload.fhirPatientId && actions.payload.fhirPatientId.length > 0) {
            query += `fhir_patient_id=${actions.payload.fhirPatientId}&`;
        }
        if (query.length > 0) {
            query = query.substring(0, query.length - 1);
        }
        const response = yield call(validateUser, query);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(registerActions.disableLoader({}));
        } else {
            yield put(registerActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === REGISTER_REQUEST) {
        yield put(registerActions.enableLoader({}));
        const response = yield call(registerUserV2, actions.payload);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(registerActions.disableLoader({}));
            yield put(registerActions.verifyCodeResponse(data));
        } else {
            yield put(registerActions.registerFailed());
            yield put(registerActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            if (data.isDuplicate === true && data.code === 'PATIENT_VERIFIED') {
                console.log("Patient is already exists");
            } else if (
                data.isDuplicate === true &&
                data.code === 'PATIENT_NOT_VERIFIED'
            ) {
                console.log("Patient is already exists, but not verified");
            } else {
                console.log("Api Failed");
                //apiFailure(data) 
            };
        }
    }
}